/**
*	@description Script used to implement javascript inheritance functionality
*/

/**
*	@description Method used to extend from a prototyped function
*	@param superClass A prototyped function to be inherited
*/
Function.prototype.Extend = function (superClass) {

	/************* USAGE ***************

		var Class1 = function () { };
		
		Class1.prototype.init = function () {
			// Implement init logic in parent function
		};

		var Class2 = function () {
			// Invoke init method of parent function
			this.init();
		};

		// Inherit parent function
		Class2.Extend(Class1);
	
	************************************/

	this.prototype = new superClass();

	this.prototype.getSuperClass = function () {
		return superClass;
	};

	this.getSuperClass = this.prototype.getSuperClass;

	return this;
};

/**
*	@description Method used to invoke overridden methods in the parent function
*	@param context A method context
*	@param methodName A method name in the parent function
*	@param args Arguments to pass into the parent function method
*/
Function.prototype.Base = function (context, methodName, args) {

	/************* USAGE ***************

		var Class1 = function () { };
		
		Class1.prototype.init = function (arg1, arg2) {
			// Implement init logic in parent function
		};

		var Class2 = function () {
			// Invoke init method of child function
			this.init();
		};

		// Inherit parent function
		Class2.Extend(Class1);

		Class2.prototype.init = function () {
			// Invoke init method of parent function
			Class2.Base(this, 'init', ['value1', 'value2']);

			// Implement init logic in child function
		};
	
	************************************/

	var method = methodName != null
		? this.getSuperClass().prototype[methodName]
		: this.getSuperClass();

	if (!args) {
		return method.call(context);
	} else {
		return method.apply(context, args);
	}
};
